module.exports = __webpack_public_path__ + "img/autoplay-sm.61dc8638.svg";